import React, {useEffect, useState} from 'react';
import Select from "./common/Select";
import Helper from "../common/helper";
import Bitrix24 from "../server/bitrix24";

const CardOrder = ({deal = {}, setDeal, company, optionsDogovor = [], optionsPrice = [], optionsPodrazdelenie = [], optionsAddress = []}) => {

    const bitrixConnect = new Bitrix24();

    const [searchCompany, setSearchCompany] = useState(deal.COMPANY);
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        setSearchCompany(deal.COMPANY)
    }, [deal.COMPANY])

    useEffect(() => {

        const timeout = setTimeout(() => {
            bitrixConnect.loadCompanySearch(searchCompany).then((result) => {
                if (result.length === 0) {
                    setCompanies([])
                } else {
                    setCompanies(result)
                }
            })
        }, 1000)

        return () => clearTimeout(timeout)
    }, [searchCompany])

    const selectCompany = (company) => {
        setSearchCompany(company.TITLE)
        setDeal(prevState => ({...prevState, COMPANY_ID: company.ID}))
    }

    return (
        <div className="row m-3">
            <div className="col-4">
                <div className="row">
                    <div className="mb-0">
                        <div className="row">
                            <div className="col-6">
                                <label className="form-label col-form-label-sm">Номер</label>
                                <input name="UF_CRM_DEAL_NUMBER" type="text" className="form-control form-control-sm"
                                       value={deal.UF_CRM_DEAL_NUMBER}
                                       onChange={(event) => setDeal(prevState => ({...prevState, UF_CRM_DEAL_NUMBER: event.target.value}))}
                                       disabled/>
                            </div>
                            <div className="col-6">
                                <label className="form-label col-form-label-sm">Дата</label>
                                <input name="UF_CRM_DEAL_DATE" type="date" className="form-control form-control-sm"
                                       value={deal.UF_CRM_DEAL_DATE}
                                       onChange={(event) => setDeal(prevState => ({...prevState, UF_CRM_DEAL_DATE: event.target.value}))}/>
                            </div>
                        </div>
                    </div>
                    <div className="mb-0">
                        <label className="form-label col-form-label-sm">Контрагент</label>
                        <input id="company" name="COMPANY" type="text" className="form-control form-control-sm"
                               value={searchCompany}
                               onChange={(event) => setSearchCompany(event.target.value)}
                               required/>
                            <ul className="list-search" id="searchResult">
                                {companies.length > 0 ? companies.map(company => {
                                    return (
                                        <li key={company.ID} onClick={() => selectCompany(company)}>{company.TITLE}</li>
                                    )
                                }) : (
                                    <li>Не найдено</li>
                                )}

                            </ul>
                    </div>
                    <div className="mb-0">
                        <Select name="UF_CRM_DEAL_PODRAZDELENIE"
                                label="Подразделение"
                                value={deal.UF_CRM_DEAL_PODRAZDELENIE}
                                options={optionsPodrazdelenie}
                                onChange={(val) => setDeal(prevState => ({...prevState, UF_CRM_DEAL_PODRAZDELENIE: val}))}/>
                    </div>
                    <div className="mb-0">
                        <Select name="DEAL_ADDRESS"
                                label="Адрес доставки"
                                value={deal[Helper.fields.DEAL_ADDRESS]}
                                options={optionsAddress}
                                onChange={(val) => setDeal(prevState => ({
                                    ...prevState,
                                    [Helper.fields.DEAL_ADDRESS]: val,
                                    UF_CRM_DEAL_ADDRESS: optionsAddress.find((item) => item.value === val)?.name
                                }))}/>

                    </div>
                </div>
            </div>
            <div className="col-4">
                <div className="row">
                    <div className="mb-0">
                        <div className="row">
                            <div className="col-4">
                                <div className="form-check">
                                    <input id="UF_CRM_DEAL_NEVIPOLNEN" name="UF_CRM_DEAL_NEVIPOLNEN" type="checkbox" className="form-check-input"
                                       checked={deal.UF_CRM_DEAL_NEVIPOLNEN}
                                       onChange={() => setDeal(prevState => ({...prevState, UF_CRM_DEAL_NEVIPOLNEN: !deal.UF_CRM_DEAL_NEVIPOLNEN}))}/>
                                    <label htmlFor="UF_CRM_DEAL_NEVIPOLNEN" className="form-check-label col-form-label-sm">в невыполненный</label>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-check">
                                    <input id="UF_CRM_DEAL_TRANZIT" name="UF_CRM_DEAL_TRANZIT" type="checkbox" className="form-check-input"
                                       checked={deal.UF_CRM_DEAL_TRANZIT}
                                       onChange={() => setDeal(prevState => ({...prevState, UF_CRM_DEAL_TRANZIT: !deal.UF_CRM_DEAL_TRANZIT}))}/>
                                    <label htmlFor="UF_CRM_DEAL_TRANZIT" className="form-check-label col-form-label-sm">Транзит</label>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-check">
                                    <input id="UF_CRM_DEAL_UPACLIST" name="UF_CRM_DEAL_UPACLIST" type="checkbox" className="form-check-input"
                                       checked={deal.UF_CRM_DEAL_UPACLIST}
                                       onChange={() => setDeal(prevState => ({...prevState, UF_CRM_DEAL_UPACLIST: !deal.UF_CRM_DEAL_UPACLIST}))}/>
                                    <label htmlFor="UF_CRM_DEAL_UPACLIST" className="form-check-label col-form-label-sm">Упаковочный лист</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-0">
                        <div className="row">
                            <div className="col-4">
                                <Select name="UF_CRM_DEAL_PRICE"
                                        label="Тип цен"
                                        value={deal.UF_CRM_DEAL_PRICE}
                                        options={optionsPrice}
                                        onChange={(val) => setDeal(prevState => ({...prevState, UF_CRM_DEAL_PRICE: val}))}/>
                            </div>
                        </div>
                    </div>
                    <div className="mb-0">
                        <div className="row">
                            <div className="col-6">
                                <Select name="UF_CRM_DEAL_DOGOVOR"
                                        label="Договор"
                                        value={deal[Helper.fields.DEAL_DOGOVOR]}
                                        options={optionsDogovor}
                                        onChange={(val) => setDeal(prevState => ({...prevState, [Helper.fields.DEAL_DOGOVOR]: val}))}/>
                            </div>
                        </div>
                    </div>
                    <div className="mb-0">
                        <label className="form-label col-form-label-sm pe-3">Способ доставки</label>
                        <div className="form-check form-check-inline">
                            <input id="UF_CRM_DEAL_DOSTAVKA_1" name="UF_CRM_DEAL_DOSTAVKA" className="form-check-input" type="radio"
                                   checked={deal.UF_CRM_DEAL_DOSTAVKA === 'Самовывоз'}
                                   onChange={(event) => setDeal(prevState => ({...prevState, UF_CRM_DEAL_DOSTAVKA: event.target.value}))}
                                   value="Самовывоз"/>
                                <label htmlFor="UF_CRM_DEAL_DOSTAVKA_1" className="form-check-label col-form-label-sm">Самовывоз</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input id="UF_CRM_DEAL_DOSTAVKA_2" name="UF_CRM_DEAL_DOSTAVKA" className="form-check-input" type="radio"
                                   checked={deal.UF_CRM_DEAL_DOSTAVKA === 'Доставка'}
                                   onChange={(event) => setDeal(prevState => ({...prevState, UF_CRM_DEAL_DOSTAVKA: event.target.value}))}
                                   value="Доставка"/>
                                <label htmlFor="UF_CRM_DEAL_DOSTAVKA_2" className="form-check-label col-form-label-sm">Доставка</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input id="UF_CRM_DEAL_DOSTAVKA_3" name="UF_CRM_DEAL_DOSTAVKA" className="form-check-input" type="radio"
                                   checked={deal.UF_CRM_DEAL_DOSTAVKA === 'ТК'}
                                   onChange={(event) => setDeal(prevState => ({...prevState, UF_CRM_DEAL_DOSTAVKA: event.target.value}))}
                                   value="ТК"/>
                                <label htmlFor="UF_CRM_DEAL_DOSTAVKA_3" className="form-check-label col-form-label-sm">ТК</label>
                        </div>
                    </div>
                    <div className="mb-0">
                        <label className="form-label col-form-label-sm pe-3">Способ оплаты</label>
                        <div className="form-check form-check-inline">
                            <input id="DEAL_PAY_1" name="DEAL_PAY" className="form-check-input" type="radio"
                                   checked={deal.DEAL_PAY === 'Касса'}
                                   onChange={(event) => setDeal(prevState => ({...prevState, DEAL_PAY: event.target.value}))}
                                   value="Касса"/>
                                <label htmlFor="DEAL_PAY_1" className="form-check-label col-form-label-sm">Касса</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input id="DEAL_PAY_2" name="DEAL_PAY" className="form-check-input" type="radio"
                                   checked={deal.DEAL_PAY === 'сНДС'}
                                   onChange={(event) => setDeal(prevState => ({...prevState, DEAL_PAY: event.target.value}))}
                                   value="сНДС"/>
                                <label htmlFor="DEAL_PAY_2" className="form-check-label col-form-label-sm">сНДС</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input id="DEAL_PAY_3" name="DEAL_PAY" className="form-check-input" type="radio"
                                   checked={deal.DEAL_PAY === 'Взаимозачет'}
                                   onChange={(event) => setDeal(prevState => ({...prevState, DEAL_PAY: event.target.value}))}
                                   value="Взаимозачет"/>
                                <label htmlFor="DEAL_PAY_3" className="form-check-label col-form-label-sm">Взаимозачет</label>
                        </div>
                    </div>
                    {deal.DEAL_PAY === 'сНДС' && (
                        <div id="pay_tax_include" className="mb-0" >
                            <div className="form-check">
                                <input id="DEAL_PAY_TAX_INCLUDE" name="DEAL_PAY_TAX_INCLUDE" type="checkbox" className="form-check-input"
                                   checked={deal.DEAL_PAY_TAX_INCLUDE}
                                   onChange={() => setDeal(prevState => ({...prevState, DEAL_PAY_TAX_INCLUDE: !deal.DEAL_PAY_TAX_INCLUDE}))}/>
                                <label htmlFor="DEAL_PAY_TAX_INCLUDE" className="form-check-label col-form-label-sm">НДС в т.ч.</label>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="col-4">
                <div className="row">
                    <div className="mb-0">
                        <div className="row">
                            <div className="col-4">
                                <label className="form-label col-form-label-sm">Срок резерва</label>
                                <input name="UF_CRM_DEAL_SROKREZERVA" type="number"
                                       value={deal.UF_CRM_DEAL_SROKREZERVA}
                                       onChange={(event) => setDeal(prevState => ({...prevState, UF_CRM_DEAL_SROKREZERVA: event.target.value}))}
                                       className="form-control form-control-sm"/>
                            </div>
                            <div className="col-4">
                                <label className="form-label col-form-label-sm">Наценка</label>
                                <input name="UF_CRM_DEAL_NACENKA" type="number"
                                       value={deal.UF_CRM_DEAL_NACENKA}
                                       onChange={(event) => setDeal(prevState => ({...prevState, UF_CRM_DEAL_NACENKA: event.target.value}))}
                                       className="form-control form-control-sm"/>
                            </div>
                        </div>
                    </div>
                    <div className="mb-0">
                        <div className="row">
                            <div className="col-4 mb-4">
                                <label className="form-label col-form-label-sm">Лимит Отгрузки</label>
                                <input id="lmitShipment" type="text" className="form-control form-control-sm"
                                       value={deal.lmitShipment ? new Intl.NumberFormat("ru", {style: "decimal"}).format(deal.lmitShipment) : deal.lmitShipment}
                                       onChange={(event) => setDeal(prevState => ({
                                           ...prevState,
                                           lmitShipment: event.target.value.replace(',', '.').replace(/\D/g, '')
                                       }))}
                                       disabled/>
                            </div>
                            <div className="col-4 mb-4">
                                <label className="form-label col-form-label-sm">Отсрочка Платежа</label>
                                <input id="dayPayment" type="number" className="form-control form-control-sm"
                                       value={deal[Helper.fields.DEAL_OTSROCHKA]}
                                       onChange={(event) => setDeal(prevState => ({...prevState, [Helper.fields.DEAL_OTSROCHKA]: event.target.value}))}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 mb-4">
                                <label className="form-label col-form-label-sm">Долг</label>
                                <input id="debt" type="text" className="form-control form-control-sm"
                                       value={deal.debt ? new Intl.NumberFormat("ru", {style: "decimal"}).format(deal.debt) : deal.debt}
                                       onChange={(event) => setDeal(prevState => ({
                                           ...prevState,
                                           debt: event.target.value.replace(',', '.').replace(/\D/g, '')
                                       }))}
                                       disabled/>
                            </div>
                            <div className="col-4 mb-4">
                                <label className="form-label col-form-label-sm">Просроч. долг</label>
                                <input id="overdueDebt" type="text" className="form-control form-control-sm"
                                       value={deal.overdueDebt ? new Intl.NumberFormat("ru", {style: "decimal"}).format(deal.overdueDebt) : deal.overdueDebt}
                                       onChange={(event) => setDeal(prevState => ({
                                           ...prevState,
                                           overdueDebt: event.target.value.replace(',', '.').replace(/\D/g, '')
                                       }))}
                                       disabled/>
                            </div>
                        </div>
                    </div>
                    <div className="mb-0">
                        <div className="row">
                            <div className="col-6">
                                <label className="form-label col-form-label-sm">Дата доставки</label>
                                <input name="UF_CRM_DEAL_DATEDELIVERY" type="date"
                                       value={deal.UF_CRM_DEAL_DATEDELIVERY}
                                       onChange={(event) => setDeal(prevState => ({...prevState, UF_CRM_DEAL_DATEDELIVERY: event.target.value}))}
                                       className="form-control form-control-sm" required/>
                            </div>
                            <div className="col-6">
                                <input name="UF_CRM_DEAL_HOOTDELIVERY" type="checkbox" className="form-check-input"
                                       checked={deal.UF_CRM_DEAL_HOOTDELIVERY}
                                       onChange={() => setDeal(prevState => ({...prevState, UF_CRM_DEAL_HOOTDELIVERY: !deal.UF_CRM_DEAL_HOOTDELIVERY}))}/>
                                    <label className="form-check-label col-form-label-sm">Срочная доставка</label>
                            </div>
                        </div>
                    </div>
                    <div className="mb-0">
                        <label className="form-label col-form-label-sm">Статус заказа</label>
                        <input name="UF_CRM_DEAL_STATUS" type="text" className="form-control form-control-sm"
                               value={deal.UF_CRM_DEAL_STATUS}
                               onChange={(event) => setDeal(prevState => ({...prevState, UF_CRM_DEAL_STATUS: event.target.value}))}
                               disabled/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CardOrder